module.exports = "/_next/static/images/logo_WEB-f89efa3d9c223acf9f1788ac5cad9448.svg";